import React from "react";
import { Eyebrow } from "@/components/Section";
import { SEO } from "@/components/SEO";

const H2 = ({ children }) => (
  <h2 className="font-display font-bold text-xl text-ink mb-3">{children}</h2>
);

export const Impressum = () => (
  <div data-testid="impressum-page" className="max-w-4xl mx-auto px-6 sm:px-12 py-20 sm:py-28 bg-white">
    <SEO
      title="Impressum"
      description="Impressum von IT Servicepoint, Inhaber Ron Kowalewsky, Im Wiesengrund 2A, 36277 Schenklengsfeld."
      noindex
    />
    <Eyebrow>Impressum</Eyebrow>
    <h1 className="mt-6 font-display font-black text-4xl sm:text-5xl tracking-tightest text-ink">Impressum</h1>

    <div className="mt-12 space-y-8 text-muted leading-relaxed">
      <div>
        <H2>Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</H2>
        <p>IT Servicepoint<br />Ron Kowalewsky<br />Im Wiesengrund 2A<br />36277 Schenklengsfeld<br />Deutschland</p>
      </div>
      <div>
        <H2>Vertreten durch</H2>
        <p>Ron Kowalewsky (Inhaber)</p>
      </div>
      <div>
        <H2>Kontakt</H2>
        <p>
          Telefon: <a href="tel:+4966299153890" className="text-primary hover:underline">06629 9153890</a><br />
          E-Mail: <a href="mailto:info@it-servicepoint.eu" className="text-primary hover:underline">info@it-servicepoint.eu</a><br />
          Web: www.it-servicepoint.eu
        </p>
      </div>
      <div>
        <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
        <p>Ron Kowalewsky<br />Im Wiesengrund 2A<br />36277 Schenklengsfeld</p>
      </div>
      <div>
        <H2>Umsatzsteuer</H2>
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: auf Anfrage.</p>
      </div>
      <div>
        <H2>EU-Streitschlichtung</H2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
            https://ec.europa.eu/consumers/odr/
          </a>
          . Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </div>
      <div>
        <H2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</H2>
        <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      </div>
      <div>
        <H2>Haftung für Inhalte</H2>
        <p>Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Bei Bekanntwerden von Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
      </div>
      <div>
        <H2>Haftung für Links</H2>
        <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
      </div>
      <div>
        <H2>Urheberrecht</H2>
        <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
      </div>
    </div>
  </div>
);

export const Datenschutz = () => (
  <div data-testid="datenschutz-page" className="max-w-4xl mx-auto px-6 sm:px-12 py-20 sm:py-28 bg-white">
    <SEO
      title="Datenschutzerklärung"
      description="Datenschutzerklärung von IT Servicepoint nach DSGVO – transparente Informationen zur Verarbeitung Ihrer Daten."
      noindex
    />
    <Eyebrow>Datenschutz</Eyebrow>
    <h1 className="mt-6 font-display font-black text-4xl sm:text-5xl tracking-tightest text-ink">Datenschutzerklärung</h1>

    <div className="mt-12 space-y-8 text-muted leading-relaxed">
      <p>
        Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie
        gemäß der Datenschutz-Grundverordnung (DSGVO) darüber, welche Daten wir beim Besuch unserer Website
        verarbeiten und zu welchem Zweck.
      </p>

      <div>
        <H2>1. Verantwortlicher</H2>
        <p>
          Verantwortlicher im Sinne der DSGVO ist:<br />
          IT Servicepoint · Ron Kowalewsky<br />
          Im Wiesengrund 2A, 36277 Schenklengsfeld<br />
          E-Mail: <a href="mailto:info@it-servicepoint.eu" className="text-primary hover:underline">info@it-servicepoint.eu</a> · Telefon: 06629 9153890
        </p>
      </div>

      <div>
        <H2>2. Ihre Rechte als betroffene Person</H2>
        <p>Ihnen stehen bezüglich der Sie betreffenden personenbezogenen Daten folgende Rechte zu:</p>
        <ul className="mt-3 space-y-2 list-disc pl-5">
          <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
          <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
          <li>Recht auf Löschung (Art. 17 DSGVO)</li>
          <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
        </ul>
        <p className="mt-4">
          Zur Ausübung Ihrer Rechte genügt eine E-Mail an{" "}
          <a href="mailto:info@it-servicepoint.eu" className="text-primary hover:underline">info@it-servicepoint.eu</a>.
          Ihnen steht zudem ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde zu. Zuständig ist für uns der
          Hessische Beauftragte für Datenschutz und Informationsfreiheit.
        </p>
      </div>

      <div>
        <H2>3. Zugriffsdaten / Server-Logfiles</H2>
        <p>
          Beim Aufruf unserer Website werden durch den Hosting-Provider automatisch Informationen in sogenannten
          Server-Logfiles erfasst, die Ihr Browser übermittelt (z. B. Datum und Uhrzeit des Zugriffs, aufgerufene
          Seite, verwendeter Browsertyp, Betriebssystem und die anonymisierte bzw. gekürzte IP-Adresse). Diese Daten
          dienen ausschließlich der technischen Bereitstellung, Sicherheit und Stabilität der Website. Rechtsgrundlage
          ist unser berechtigtes Interesse an einem sicheren Betrieb (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
      </div>

      <div>
        <H2>4. Cookies</H2>
        <p>
          Diese Website verwendet ausschließlich technisch notwendige Cookies, die für den Betrieb und die Funktion
          erforderlich sind (z. B. zur Speicherung Ihrer Cookie-Auswahl und für die Authentifizierung im
          Administrationsbereich). Es werden keine Marketing-, Tracking- oder Analyse-Cookies eingesetzt und keine
          Daten zu Werbezwecken an Dritte übertragen. Rechtsgrundlage ist § 25 Abs. 2 TDDDG sowie Art. 6 Abs. 1
          lit. f DSGVO.
        </p>
      </div>

      <div>
        <H2>5. Kontaktaufnahme (Kontaktformular &amp; E-Mail)</H2>
        <p>
          Wenn Sie uns über das Kontaktformular oder per E-Mail kontaktieren, verarbeiten wir die von Ihnen
          angegebenen Daten (z. B. Name, E-Mail-Adresse, Telefonnummer und Ihre Nachricht), um Ihre Anfrage zu
          beantworten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung/Erfüllung eines Vertrags) bzw.
          Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung von Anfragen). Die Daten werden
          gelöscht, sobald sie für den Zweck nicht mehr erforderlich sind und keine gesetzlichen
          Aufbewahrungspflichten entgegenstehen.
        </p>
      </div>

      <div>
        <H2>6. Kostenloser Webseiten-Check</H2>
        <p>
          Für unseren kostenlosen Webseiten-Check verarbeiten wir die von Ihnen angegebene Internetadresse (URL) sowie
          Ihre E-Mail-Adresse, um die Analyse durchzuführen und Ihnen das Ergebnis zukommen zu lassen. Rechtsgrundlage
          ist Art. 6 Abs. 1 lit. b und lit. f DSGVO. Eine Nutzung Ihrer Daten zu Werbezwecken erfolgt nur mit Ihrer
          Einwilligung.
        </p>
      </div>

      <div>
        <H2>7. Chat-Assistent</H2>
        <p>
          Sofern unsere Website einen Chat-Assistenten anbietet, verarbeiten wir die von Ihnen in den Chat
          eingegebenen Inhalte, um Ihre Fragen zu beantworten. Zur Erzeugung der Antworten können Ihre Eingaben an
          einen spezialisierten Dienstleister für Sprachverarbeitung übermittelt werden. Bitte geben Sie im Chat
          <strong className="text-ink"> keine sensiblen oder vertraulichen personenbezogenen Daten</strong> ein.
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer komfortablen
          Erstberatung). Für vertrauliche Anliegen nutzen Sie bitte das Kontaktformular, Telefon oder E-Mail.
        </p>
      </div>

      <div>
        <H2>8. SSL-/TLS-Verschlüsselung</H2>
        <p>
          Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine
          SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am „https://“ in der Adresszeile
          Ihres Browsers.
        </p>
      </div>

      <div>
        <H2>9. Speicherdauer</H2>
        <p>
          Wir verarbeiten und speichern personenbezogene Daten nur so lange, wie es für die Erreichung des jeweiligen
          Zwecks erforderlich ist oder gesetzliche Aufbewahrungsfristen dies vorschreiben. Danach werden die Daten
          routinemäßig gelöscht.
        </p>
      </div>

      <div>
        <H2>10. Widerspruch gegen Werbe-E-Mails</H2>
        <p>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von nicht
          ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen.
        </p>
      </div>

      <p className="pt-4 text-sm">Stand: Juni 2026</p>
    </div>
  </div>
);
